import type { Action } from '../common/actions'
import { isType } from '../common/actions'
import {
    PaymentInfoFetched,
    PlanChangeFailed,
    PlanChangeStarted,
    PlanChangeSucceeded,
    PurchaseFailed,
    PurchaseStarted,
    PurchaseSucceeded,
    StorageProductsFetched,
    UserStoragePlanFetched,
} from './actions'

export type StorageState = {
    availableProducts: StripeProduct[]
    userGrants: UserGrant[]
    paymentInfo: StripePaymentInfoResponse | null
    isUpdatingStoragePlan: boolean
}

const initialState = {
    availableProducts: [],
    userGrants: [],
    paymentInfo: null,
    isUpdatingStoragePlan: false,
}

export const storagePlanReducer = (
    state: StorageState = initialState,
    action: Action,
): StorageState => {
    if (isType(action, StorageProductsFetched)) {
        return {
            ...state,
            availableProducts: action.payload,
        }
    }

    if (isType(action, UserStoragePlanFetched)) {
        return {
            ...state,
            userGrants: action.payload,
        }
    }
    if (isType(action, PaymentInfoFetched)) {
        return {
            ...state,
            paymentInfo: action.payload,
        }
    }

    if (isType(action, PurchaseStarted) || isType(action, PlanChangeStarted)) {
        return {
            ...state,
            isUpdatingStoragePlan: true,
        }
    }
    if (
        isType(action, PurchaseSucceeded) ||
        isType(action, PurchaseFailed) ||
        isType(action, PlanChangeSucceeded) ||
        isType(action, PlanChangeFailed)
    ) {
        return {
            ...state,
            isUpdatingStoragePlan: false,
        }
    }
    return state
}

export const storagePlanReducerMapObj = {
    storagePlan: storagePlanReducer,
}

export type StateWithStoragePlan = StateOfReducerMapObj<
    typeof storagePlanReducerMapObj
>
